import React from 'react';
import { InputAdornment } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { FormInputText } from '../../../../form-components/FormInputText';
import { FormInputComma } from '../../../../form-components/FormInputComma';

import {
  FormFieldRow,
  FormFieldGroupHalf,
  FormFieldLabel,
  PointMinUseHint,
  ErrorFieldWrapper,
  disabledInputStyle,
  textInputStyle,
} from './EnterSaleInfoModalStyled';

// InputAdornment 스타일 (다른 섹션의 원/회/개 어드먼트와 동일한 톤)
const adornmentStyle = { color: '#737373', fontSize: '13px', fontWeight: 500 };

/**
 * 포인트 사용 필드 (보유 포인트 / 사용할 포인트)
 *
 * 수강권 / 이용권 / 일반상품 3개 섹션의 미수금·결제금액 행 바로 위에서 공통으로 사용된다.
 * 노출 여부(정식회원 + 지점 포인트 사용 설정 on)는 usePointUsage 훅에서 계산해 isVisible prop 으로 받는다.
 */
const PointUsageFields = ({
  isVisible,
  control,
  availablePoint,
  minUsePoint,
  usablePointLimit,
  errorFields,
  setErrorFields,
  formatInteger,
}) => {
  const { t } = useTranslation();

  if (!isVisible) return null;

  return (
    <FormFieldRow>
      <FormFieldGroupHalf>
        <FormFieldLabel>{t('보유 포인트')}</FormFieldLabel>
        <FormInputText
          control={control}
          disabled
          color="info"
          sx={disabledInputStyle}
          variant="outlined"
          name="availablePointDisplay"
          size="small"
          staticValue={formatInteger(availablePoint)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end" sx={adornmentStyle}>
                P
              </InputAdornment>
            ),
          }}
        />
      </FormFieldGroupHalf>
      <FormFieldGroupHalf>
        {/* 힌트는 라벨 옆에 붙여 행 높이를 늘리지 않는다 (이용기간·이용횟수 안 밀림).
            문구가 길어지면 말줄임으로 한 줄 유지하고, 라벨 행 전체 hover(title)로 전문을 보여준다. */}
        {(() => {
          const hintBody =
            minUsePoint > 0 || usablePointLimit != null
              ? [
                  minUsePoint > 0 && t('최소 {{min}}P', { min: formatInteger(minUsePoint) }),
                  usablePointLimit != null && t('최대 {{max}}P', { max: formatInteger(usablePointLimit) }),
                ]
                  .filter(Boolean)
                  .join(' · ')
              : '';
          const hintText = hintBody ? `(${hintBody})` : '';
          return (
            <FormFieldLabel
              title={hintText || undefined}
              sx={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap', minWidth: 0, overflow: 'hidden' }}>
              {t('사용 포인트')}
              {hintText && <PointMinUseHint>{hintText}</PointMinUseHint>}
            </FormFieldLabel>
          );
        })()}
        <ErrorFieldWrapper hasError={errorFields?.usedPoint}>
          <FormInputComma
            control={control}
            name="usedPoint"
            placeholder="0"
            sx={textInputStyle}
            endAdornmentText="P"
            onAmountChange={() => setErrorFields(prev => ({ ...prev, usedPoint: false }))}
          />
        </ErrorFieldWrapper>
      </FormFieldGroupHalf>
    </FormFieldRow>
  );
};

export default PointUsageFields;
